export const navigation = [
  // {
  //   name: 'CHỨC NĂNG CHÍNH',
  //   url: '/dashboard',
  //   icon: 'icon-speedometer',
  //   // badge: {
  //   //   variant: 'info',
  //   //   text: 'NEW'
  //   // }
  // },

  {
    // name: 'Giám sát các thông số điện',
    name: 'giamsat',
    url: '/giamsat',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'chisocongto',
        url: '/#/giamsat/chisocongtokh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 8
      },
      {
        name: 'tsvhcto',
        url: '/#/giamsat/thongsovanhanh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 9
      },
      {
        name: 'bieudophutai',
        url: '/#/giamsat/thongsophutai',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 10
      },
      // {
      //   name: 'dongbocmis',
      //   url: '/#/ghichiso/dongbocmis',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 7
      // },
      // {
      //   name: 'doctucthoidiemdo',
      //   url: '/#/giamsat/docdiemdo',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 11
      // },
      // {
      //   name: 'docdcu',
      //   url: '/#/giamsat/docdulieudcu',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 12
      // },
      // {
      //   name: 'giamsatcambien',
      //   url: '/#/giamsat/giamsatcambien',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 14
      // },
    ]
  },
  {
    name: 'baocao',
    url: '/baocao',
    icon: 'fa fa-align-justify',
    children: [
      // {
      //   name: 'Quản lý báo cáo',
      //   url: '/#/baocao/quanlybaocao',
      //   icon: 'fa fa-caret-right fa-1', 
      //   machucnang: 32
      // },
      {
        name: 'thongkesanluong',
        url: '/#/baocao/thongkesanluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 18
      },
      // {
      //   name: 'thongsochisokhachhang',
      //   url: '/#/baocao/thongsochisokhachhang',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 18
      // },
      {
        name: 'thongkemangtai',
        url: '/#/baocao/thongkemangtai',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 22
      },

      // {
      //   name: 'Báo cáo xử lý RF/GPRS',
      //   url: '/#/baocao/baocaoxuly',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 29
      // },
      {
        name: 'thongkechatluong',
        url: '/#/thongketrangthai/thongkechatluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 5
      },
      {
        name: 'trangthaiketnoi',
        url: '/#/thongketrangthai/rfmesh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 6
      },
      {
        name: 'doisoat',
        url: '/#/baocao/doisoat',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 32
      },
      {
        name: 'baocaolichsuloi',
        url: '/#/baocao/baocaolichsuloi',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 34
      }
      // {
      //   name: 'chatluongrouting',
      //   url: '/#/thongketrangthai/chatluongrouting',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 21
      // },
      // {
      //   name: 'Báo cáo chất lượng điện năng',
      //   url: '/#/baocao/baocaochatluongdiennang',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 31
      // },
      // {
      //   name: 'Báo cáo lịch sử thay công tơ',
      //   url: '/#/baocao/baocaolichsuthaycongto',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 32
      // }
      // {
      //   name: 'baocaochatluong',
      //   url: '/#/baocao/baocaochatluong',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 32
      // },
      // {
      //   name: 'Báo cáo lộ đường dây',
      //   url: '/#/baocao/baocaoloduongday',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 32
      // }
    ]
  },
  {
    name: 'tienich',
    url: '/#/tienich',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'uoctinhtonthat',
        url: '/#/tienich/uoctinhtonthat',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        name: 'xuatchiso',
        url: '/#/tienich/xuatchiso',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 20
      },
      {
        name: 'sosanhsanluong',
        url: '/#/tienich/sosanhsanluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 23
      },
      // {
      //   name: 'giaonhan110',
      //   url: '/#/tienich/giaonhan110',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 1
      // },
      {
        name: 'quanlymodemdcu',
        url: '/#/tienich/quanlymodemdcu',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      // {
      //   name: 'laychiso',
      //   url: '/#/tienich/laychiso',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 1
      // },
      // {
      //   name: 'laysanluongngay',
      //   url: '/#/tienich/laysanluongngay',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 1
      // }
      // {
      //   name: 'giamsatrepeater',
      //   url: '/#/tienich/giamsatrepeater',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 12
      // },
      // {
      //   name: 'nhatkylapdatvanhanh',
      //   url: '/#/tienich/nhatkylapdatvanhanh',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 1
      // }


    ]
  },
  {
    name: 'quanly',
    url: '/quanly',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'quanlynguoidung',
        url: '/#/quanly/nguoidung',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        name: 'thongkedangnhap',
        url: '/#/quanly/thongkedangnhap',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 16
      },
      {
        name: 'khaibaothongtinkh',
        url: '/#/nhapthongtinkh/khaibaokhachhangcmis',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 13
      },
      // {
      //   name: 'diemdokhaibaosaitt',
      //   url: '/#/nhapthongtinkh/diemdokhaibaosai',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 14
      // },
      {
        name: 'khtreothao',
        url: '/#/nhapthongtinkh/khachhangtreothao',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 15
      }
      ,
      {
        name: 'khaibaodanhmuctram',
        url: '/#/nhapthongtinkh/danhmuctram',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 15
      }
      // ,
      // {
      //   name: 'Quản lý Repeater',
      //   url: '/#/quanly/repeater',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 15
      // }
      // ,
      // {
      //   name: 'Quản lý giám sát cảm biến',
      //   url: '/#/quanly/quanlygiamsatcambien',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 15
      // }
    ]
  },
  {
    name: 'canhbao',
    url: '/canhbao',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'thietlapcanhbao',
        url: '/#/canhbao/thietlapcanhbao',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 27
      },
      // {
      //   name: 'cauhinhnhan',
      //   url: '/#/canhbao/cauhinhnhan',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 5
      // },
      {
        name: 'canhbaovanhanh',
        url: '/#/canhbao/canhbaovanhanh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 92
      },
      // {
      //   name: 'canhbaomatdien',
      //   url: '/#/canhbao/canhbaomatdien',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 5
      // },
      {
        name: 'sukiencongto',
        url: '/#/canhbao/sukiencongto',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 28
      },
      // {
      //   name: 'chisobatthuong',
      //   url: '/#/canhbao/chisobatthuong',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 29
      // },
      // {
      //   name: 'canhbaocambien',
      //   url: '/#/canhbao/canhbaocambien',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 30
      // },
    ]
  },

  // {
  //   name: 'Quản lý công tơ 2 chiều',
  //   url: '/quanly',
  //   icon: 'fa fa-align-justify',
  //   children: [
  //     {
  //       name: 'Khai báo công tơ 2 chiều',
  //       url: '/#/quanly/quanlycongto2chieu',
  //       icon: 'fa fa-caret-right fa-1',
  //       machucnang: 1
  //     },
  //     {
  //       name: 'Chỉ số công tơ 2 chiều',
  //       url: '/#/quanly/danhsachcongto2chieu',
  //       icon: 'fa fa-caret-right fa-1',
  //       machucnang: 2
  //     },

  //   ]
  // },



];




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-header-nav/_nav.ts